import * as actionTypes from "../actionTypes";
import createReducer from "../lib/createReducer";

export const defaultState = {};

export function apiToReduxLibrary(library) {
	return {
		allServices: library.all_services,
		description: library.description,
		disabled: !!library.disabled,
		name: library.name,
		pricing: library.pricing,
		profiles: library.profiles,
		services: library.services,
		title: library.title,
		targetsLoaded: false,
	};
}

const LIBRARY_SET_AVAILABLE = (state, action) => {
	const { libraries } = action;

	const nextState = { ...state };
	libraries.forEach(library => {
		const name = library.name;
		nextState[name] = apiToReduxLibrary(library);
	});

	return nextState;
};

const LIBRARY_TARGETS_SET = (state, action) => {
	const { libraryName } = action;
	if (!libraryName || !state[libraryName]) {
		return state;
	}
	return {
		...state,
		[libraryName]: {
			...state[libraryName],
			targetsLoaded: true,
		},
	};
};

const LIBRARY_TARGETS_RESET = state => {
	const nextState = { ...state };
	Object.keys(state).forEach(name => {
		nextState[name] = {
			...nextState[name],
			targetsLoaded: false,
		};
	});
	return nextState;
};

const handlers = {};
handlers[actionTypes.LIBRARY_SET_AVAILABLE] = LIBRARY_SET_AVAILABLE;
handlers[actionTypes.TARGETS_SET] = LIBRARY_TARGETS_SET;
handlers[actionTypes.TARGETS_RESET] = LIBRARY_TARGETS_RESET;
export default createReducer(defaultState, handlers);
